import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '@/store/convo/state'
import { RootState } from '@/store'
import { IStatement } from '@/model/statement'
import convoStore from '@/store/convo/convo-store'
import statementStore from '@/store/statement/statement-store'
import { ConvoMeta } from '@/model/convo';

export default async function removeCommentStatement(context: BareActionContext<ConvoState, RootState>, statement: IStatement)
{
  const convoMeta = <ConvoMeta>convoStore.state.convo.meta

  if (convoMeta.newCommentStatements.indexOf(statement) >= 0) {
    convoMeta.newCommentStatements.splice(convoMeta.newCommentStatements.indexOf(statement), 1)
    statementStore.dispatchSetStatementQuery()
  }

  return
}
